import React from 'react'
import { Box, Typography, Button, FormControl, InputLabel, Select, MenuItem, Grid } from '@mui/material';
import DynamicTable from "../common/DynamicTable"
import { useTranslation } from 'react-i18next';
const headers = ['recentlyDeletedItems', 'date', 'recover'];

export default function DeleteData() {
    const { t } = useTranslation();
    return (
        <Box
            sx={{
                position: 'relative',
                gap: '20px',
                borderRadius: '10px',
                margin: { xs: '10px', sm: '20px', md: '20px 40px' },
                background: '#FFFFFF',
                border: '1px solid #A5DCF3',
                boxShadow: '-2px 2px 5px 0px rgba(0,0,0,0.25)',
                padding: { xs: '10px', sm: '20px' }
            }}
        >
            <Box
                sx={{
                    background: '#647490',
                    boxShadow: '-2px 2px 5px 0px rgba(0,0,0,0.25)',
                    color: '#FFFFFF',
                    fontFamily: 'Roboto',
                    borderRadius: "8px",
                    fontWeight: 600,
                    fontSize: { xs: '18px', sm: '24px' },
                    lineHeight: '100%',
                    letterSpacing: '0%',
                    padding: '12px',
                    marginBottom: '20px',
                    textAlign: 'center'
                }}
            >
                {t("deleteDataPermanently")}
            </Box>
            <Box sx={{ mt: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
                <Grid container spacing={{ xs: 1, sm: 2 }} alignItems="center">
                    <Grid item xs={12} md={5}>
                        <Box>
                            <InputLabel
                                sx={{
                                    fontFamily: 'Roboto',
                                    fontWeight: 500,
                                    fontSize: { xs: '16px', sm: '20px' },
                                    lineHeight: '100%',
                                    letterSpacing: '0%',
                                    color: '#1F242E',
                                    mb: 1
                                }}
                            >
                                {t("module")}
                            </InputLabel>
                            <FormControl fullWidth>
                                <Select
                                    displayEmpty
                                    defaultValue=""
                                    sx={{
                                        height: 55,
                                        borderRadius: '16px',
                                        borderWidth: '2px',
                                        padding: '16px 24px',
                                        border: '2px solid #183059'
                                    }}
                                >
                                    <MenuItem value="">{t("Select organization")}</MenuItem>
                                    <MenuItem value="org1">{t("organization")} 1</MenuItem>
                                    <MenuItem value="org2">{t("organization")} 2</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>
                    </Grid>

                    <Grid item xs={12} md={5}>
                        <Box>
                            <InputLabel
                                sx={{
                                    fontFamily: 'Roboto',
                                    fontWeight: 500,
                                    fontSize: { xs: '16px', sm: '20px' },
                                    lineHeight: '100%',
                                    letterSpacing: '0%',
                                    color: '#1F242E',
                                    mb: 1
                                }}
                            >
                                {t("duration")}
                            </InputLabel>
                            <FormControl fullWidth>
                                <Select
                                    displayEmpty
                                    defaultValue=""
                                    sx={{
                                        height: 55,
                                        borderRadius: '16px',
                                        borderWidth: '2px',
                                        padding: '16px 24px',
                                        border: '2px solid #183059'
                                    }}
                                >
                                    <MenuItem value="">{t("Select duration")}</MenuItem>
                                    <MenuItem value="duration1">{t("Last")} 7 {t("Days")}</MenuItem>
                                    <MenuItem value="duration2">{t("Last")} 30 {t("Days")}</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>
                    </Grid>

                    <Grid item xs={12} md={2} sx={{ textAlign: 'right', display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            sx={{
                                width: { xs: '100%', md: '106px' },
                                height: '55px',
                                borderRadius: '8px',
                                borderWidth: '1px',
                                padding: '16px 24px',
                                background: '#F2F2F3',
                                border: '1px solid #414958',
                                textTransform: 'none'
                            }}
                        >
                            {t("delete")}
                        </Button>
                    </Grid>
                </Grid>
            </Box>
            <DynamicTable headers={headers} />
        </Box>
    )
}